/* eslint-disable max-lines */
import { fetchCohortStats } from 'actions/cohorts';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getCohortStats } from 'selectors/cohorts';
import { useSelector } from 'store';
import { Cohort } from 'types';

type ComponentProps = {
  cohort: Cohort;
};

const CohortStats: React.FC<ComponentProps> = ({ cohort }) => {
  const dispatch = useDispatch();

  const stats = useSelector(getCohortStats);

  useEffect(() => {
    dispatch(fetchCohortStats({ cohortId: cohort.uuid }));
  }, [dispatch, cohort]);

  if (!stats)
    return (
      <div className="mt-4 flex flex-col gap-1 items-end">
        <span>Remaining transfers:</span>
        <span>Data not available</span>
      </div>
    );

  return (
    <div className="flex flex-col items-end text-body">
      <span>Remaining transfers:</span>
      <span>{(cohort?.config.insight_seats || 0) - stats.license_transfers.insight} Insight</span>
      <span>{(cohort?.config.prevent_seats || 0) - stats.license_transfers.prevent} Prevent</span>
    </div>
  );
};

export default CohortStats;
